import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full'
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./pages/dashboard/dashboard.module').then( m => m.DashboardPageModule)
  },
  {
    path: 'stats-te',
    loadChildren: () => import('./pages/stats-te/stats-te.module').then( m => m.StatsTePageModule)
  },
  {
    path: 'login',
    loadChildren: () => import('./pages/login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: 'stats-th',
    loadChildren: () => import('./pages/stats-th/stats-th.module').then( m => m.StatsThPageModule)
  },
  {
    path: 'unavailable',
    loadChildren: () => import('./pages/unavailable/unavailable.module').then( m => m.UnavailablePageModule)
  },
  {
    path: 'reports',
    loadChildren: () => import('./pages/reports/reports.module').then( m => m.ReportsPageModule)
  },
  {
    path: 'notifications',
    loadChildren: () => import('./pages/notifications/notifications.module').then( m => m.NotificationsPageModule)
  },
  {
    path: 'settings',
    loadChildren: () => import('./pages/settings/settings.module').then( m => m.SettingsPageModule)
  },
  {
    path: 'noticeconfirm',
    loadChildren: () => import('./pages/reportconfirm/reportconfirm.module').then( m => m.ReportconfirmPageModule)
  },
  {
    path: 'aboutus',
    loadChildren: () => import('./pages/aboutus/aboutus.module').then( m => m.AboutusPageModule)
  },
  {
    path: 'install',
    loadChildren: () => import('./pages/install/install.module').then( m => m.InstallPageModule)
  },
  {
    path: 'howto',
    loadChildren: () => import('./pages/howto/howto.module').then( m => m.HowtoPageModule)
  },
  {
    path: 'health',
    loadChildren: () => import('./pages/health/health.module').then( m => m.HealthPageModule)
  },
  {
    path: 'devicefilter',
    loadChildren: () => import('./pages/devicefilter/devicefilter.module').then( m => m.DevicefilterPageModule)
  },
  {
    path: 'viewsettings',
    loadChildren: () => import('./pages/viewsettings/viewsettings.module').then( m => m.ViewsettingsPageModule)
  }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
